import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'DriveCore',
  brandName: 'DriveCore',
  description: 'Sistema de agendamento para instrutores de condução',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Instrutor de condução em aula',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Aluno aprendendo a conduzir',
  },
  testimonials: [
    {
      name: 'Jorge Almeida',
      role: 'Instrutor de Condução',
      text: 'Com o DriveCore, os meus alunos podem marcar as aulas de forma autónoma, o que me poupa imenso tempo em chamadas.',
      image: testimonial1,
    },
    {
      name: 'Beatriz Santos',
      role: 'Aluna',
      text: 'Marcar as aulas online é super prático. Consigo ver todos os horários do meu instrutor e escolher o melhor para mim.',
      image: testimonial2,
    },
    {
      name: 'Escola de Condução Safety',
      role: 'Diretor da Escola',
      text: 'Este sistema otimizou a gestão de todas as aulas e instrutores. A organização melhorou 100%.',
      image: testimonial3,
    },
  ],
}

export default config
